<ng-container *ngIf="open">
  <div
    class="gw-fixed gw-inset-0 gw-z-[1000] gw-cursor-default"
    [class.gw-drawer-backdrop]="overlay"
    [class.gw-bg-transparent]="!overlay"
    aria-hidden="true"
    (click)="onBackdropClick()"
  ></div>
  <tui-drawer class="gw-z-[1001]" [direction]="direction" [overlay]="false">
    <header>
      <h2 tuiHeader>
        <ng-container *ngIf="showHeaderTitle">
          <div
            class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-gap-small gw-text-text-primary gw-text-[16px]"
          >
            <button
              *ngIf="showBackButton"
              tuiIconButton
              type="button"
              appearance="icon"
              size="s"
              class="gw-shrink-0"
              [tuiHint]="backButtonLabel || null"
              tuiHintDirection="top"
              [attr.aria-label]="backButtonLabel"
              (click)="onBackClick($event)"
            >
              <tui-icon
                icon="@phi.arrow-left"
                [style.font-size.rem]="1.2"
                class="gw-text-text-primary"
              />
            </button>
            <div class="gw-flex gw-min-w-0 gw-flex-1 gw-flex-col">
              <div *ngIf="title" tuiTitle>{{ title }}</div>
              <div *ngIf="subtitle" tuiSubtitle>{{ subtitle }}</div>
            </div>
          </div>
        </ng-container>
        <div tuiAccessories>
          <button
            tuiIconButton
            type="button"
            appearance="icon"
            size="s"
            [attr.aria-label]="closeButtonLabel"
            (click)="close()"
          >
            <tui-icon [icon]="closeIcon" />
          </button>
        </div>
      </h2>
    </header>

    <div
      class="gatewee-drawer__body gw-p-medium gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-hidden"
    >
      <ng-content />
    </div>

    <!-- Taiga `tui-drawer`: actions live in `<footer>` as a direct child (see Drawer KIT “Full”). -->
    <ng-content select="footer" />
  </tui-drawer>
</ng-container>
